module.exports = __webpack_public_path__ + "img/g.adefbffa.png";